<template>
  <div class="bg">
    <div class="top">
      <div class="text">
        <div class="title">
          Respondent Recruiting
        </div>
        <div class="value">
          We provide quality recruiting service for thousands of research studies, for both qualitative or quantitative research methodologies. Our success in recruitment is based on dedicated work, network building, & our innovative communication technology application. Our team has cumulated more than 15 years of experience in this arena. And during this time, we have continuously expanded & refreshed our panels which has allowed us to support our clients by bringing quality respondents to their studies.

        </div>
        <div><button @click="contact">REQUEST A BID</button></div>
      </div>
    </div>

    <div class="logo">
      <div class="title">We connect with people through our proprietary panels and alliance partners</div>
      <div class="value">
        <div class="img" @click="$router.push('/physicians?source=respondent')">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/hxl.png">
          <div class="text">HCP Panel</div>
        </div>
        <div class="img" @click="$router.push('/patients?source=respondent')">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/flc.png">
          <div class="text">Patients Panel</div>
        </div>
        <div class="img" @click="$router.push('/consumer?source=respondent')">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/djs.png">
          <div class="text">Consumer Panel</div>
        </div>
        <div class="img">
          <a href="https://www.appa360.com" target="_blank">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png">
            <div class="text">APPA</div>
          </a>
        </div>
      </div>
    </div>

    <div class="picture">
      <div class="title"></div>
      <div class="value">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/HCP.jpg">
          <div class="text">HCP</div>
        </div>
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/patients&Caregivers.jpg">
          <div class="text">Patients & Caregivers</div>
        </div>
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/technicians&Engineers.jpg">
          <div class="text">Technicians & Engineers</div>
        </div>
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/consumer.jpg">
          <div class="text">Consumers</div>
        </div>
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/shoppers.jpg">
          <div class="text">Shoppers</div>
        </div>
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/businessProfessionals.jpg">
          <div class="text">Business Professionals</div>
        </div>
      </div>
    </div>

    <div class="recommended">
      <div class="title">
        Stringent Recruitment Process to ensure Speed & Quality
      </div>
      <div class="value">
        <div class="box one">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondent1.png">
          <div class="text">
            Member finds other members

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondent2.png">
          <div class="text">
            Online & Offline advertising

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondent4.png">
          <div class="text">
            Proprietary Panels

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondent3.png">
          <div class="text">
            Strategic Partners

          </div>
        </div>
      </div>
    </div>

    <div class="country">
      <div class="title">Asia Coverage & Local Expertise</div>
      <div class="value">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/china.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/korea.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/japan.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/hongKong.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/vietnam.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/thailand.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/philippines.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/taiWan.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/malaysia.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/singapore.png">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/india.png">

        </div>
        <div class="text">
          We are experienced in multiple-market studies, covering 14 Asian countries/markets & India. We have intimate knowledge of these markets and also well aware of the differences in cultures and local practices that you have to take into consideration in designing & conducting research.

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      } // 如果没有cookie就设置cookie
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "respondent",
          source: "",
          information: "Solutions_respondent"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "respondent",
          source: this.$route.query.source,
          information: "Solutions_respondent"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondent.jpg");
  background-size: cover;
  background-attachment: fixed;
}
.top {
  background-color: #fff;
  padding: 70px 200px;
  // height: 600px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondentbg.png");
  background-size: cover;
  .text {
    color: #fff;
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .value {
      font-size: 20px;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.recommended,
.Consultants {
  background-color: #fff;
  padding: 120px;
  text-align: center;
  .title {
    font-size: 40px;
    font-weight: 700;
    padding-bottom: 60px;
  }
  .value {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    // padding: 50px;
    .box {
      width: 20.5%;
      img {
        width: 100px;
        margin-bottom: 30px;
      }
      .text {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
      }
    }
    .one {
      margin-top: 15px;
      img {
        margin-bottom: 25px;
      }
    }
  }
}
.country {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 50px 120px;
  .title {
    font-size: 40px;
    font-weight: 700;
    color: #2cb1e9;
  }
  .value {
    padding: 50px;
    .img {
      display: flex;
      justify-content: space-between;
      img {
        width: 80px;
        border-radius: 50%;
      }
    }
    .text {
      font-size: 26px;
      padding-top: 50px;
    }
  }
}
.logo {
  background-color: #fff;

  padding: 50px 120px;
  .title {
    font-size: 40px;
    font-weight: 700;
  }
  .value {
    padding: 50px;
    display: flex;
    // flex-wrap: wrap;
    justify-content: space-between;
    text-align: center;
    .img {
      // width: 19%;
    }
    img {
      height: 100px;
    }
    .text {
      font-size: 23px;
      padding-top: 30px;
      color: #2cb1e9;
      font-weight: 700;
    }
  }
  .img {
    // border: 1px solid #000;
    cursor: pointer;
    // width: 33%;
  }
}
.picture {
  background-color: #fff;

  padding: 50px 120px;
  .title {
    font-size: 40px;
    font-weight: 700;
    color: #2cb1e9;
  }
  .value {
    padding: 50px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .img {
      width: 30%;
      margin-bottom: 40px;

      img {
        width: 100%;
      }
      .text {
        background-color: #2cb1e9;
        color: #fff;
        text-align: center;
        font-size: 23px;
        padding: 5px;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .top {
    .text {
      width: 90%;
      .title {
        width: 80%;
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .recommended,
  .Consultants {
    .title {
      font-size: 80px;
      margin-bottom: 100px;
    }
    .value {
      .box {
        width: 90%;
        img {
          width: 400px;
        }
        .text {
          font-size: 70px;
          margin-bottom: 150px;
        }
      }
    }
  }
  .country {
    .title {
      font-size: 80px;
    }
    .value {
      .text {
        font-size: 70px;
      }
    }
  }
  .logo {
    .title {
      font-size: 80px;
    }
    .value {
      flex-wrap: wrap;

      .img {
        width: 90%;
        img {
          height: 500px;
        }
        .text {
          font-size: 80px;
          margin-bottom: 200px;
        }
      }
    }
  }
  .picture {
    .title {
      font-size: 80px;
    }
    .value {
      .img {
        width: 90%;
        margin-bottom: 150px;
        .text {
          font-size: 70px;
        }
      }
    }
  }
}
</style>